// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + ".82bc9fcd52f35103fbd6f80f769a71294b7bb878.chunk.js";
};